import { Circle, type GetProps, styled } from "tamagui";
import type { Status } from "../shared-types/status";
const StyledPip = styled(Circle, {
  name: "Pip",
  render: "span",
  role: "status",
  width: "$0.75",
  height: "$0.75",
  variants: {
    status: {
      neutral: {
        backgroundColor: "$surfaceStrong"
      },
      positive: {
        backgroundColor: "$bgPositiveStrong"
      },
      negative: {
        backgroundColor: "$bgNegativeStrong"
      },
      warning: {
        backgroundColor: "$bgWarningStrong"
      },
      info: {
        backgroundColor: "$bgAccentStrong"
      }
    }
  } as const,
  defaultVariants: {
    status: "neutral"
  }
});
type StyledPipProps = GetProps<typeof StyledPip>;
export type PipProps = StyledPipProps & {
  status?: Status;
};
export const Pip = ({
  status = "neutral",
  ...rest
}: PipProps) => <StyledPip status={status} {...rest} data-sentry-element="StyledPip" data-sentry-component="Pip" data-sentry-source-file="Pip.tsx" />;